/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>渠道商家列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
   <!--   <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入渠道ID"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="remark" label="品牌名称">
			</el-table-column>
			<el-table-column prop="name" label="商家名称">
			</el-table-column>
			<el-table-column prop="addr" label="地址">
			</el-table-column>
			<el-table-column prop="rateBase" label="基础折扣">
			</el-table-column>
			<el-table-column prop="rateSale" label="买单折扣">
			</el-table-column>


			<!-- <el-table-column prop="state" label="图片">
				<template slot-scope="scope">
					<el-image :src="url + scope.row.pictureUrl" lazy></el-image>
				</template>
			</el-table-column> -->


      <!--     <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import {
    getChannelMchListPage,
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {

        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          channelId: this.$route.query.id,
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    created() {
      this.getdata(this.formInline)
    },
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        let pro = {
        	"userId": JSON.parse(localStorage.getItem('userdata')).muId,
        	"page": parameter.page,
        	"pageSize": parameter.limit,
        	channelId: parameter.channelId,

        }
        getChannelMchListPage(pro)
        	.then(res => {
        		this.loading = false
        		if (res.code == 0) {
        			this.listData = res.data.list
        			// 分页赋值
        			this.pageparm.currentPage = res.data.pageNum
        			this.pageparm.pageSize = res.data.pageSize
        			this.pageparm.total = res.data.total

        		} else {
        			this.$message({
        				type: 'info',
        				message: res.msg
        			})
        		}
        	})
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },




      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/goodsmerchant.vue